<template>
    <div class="d-flex flex-wrap p-0 col-11">

        <form-field  v-if="objectClass" :label="getFieldLabel('dogHandler')"
            class="col-xs-12 col-sm-5 col-md-4 col-lg-3 p-0 mr-3 mt-3"
            :value="object.dogHandler"
            :editable="isEditable('dogHandler')"
            :feedback="liveFeedback('dogHandler')">
            <template #field>
                    <b-input
                        id="dogHandler"
                        class="w-100"
                         v-model="$v.form.dogHandler.$model"
                        :state="validateState('dogHandler')">
                    </b-input>
            </template>
        </form-field>

        <form-field  v-if="objectClass" :label="getFieldLabel('vetSpecialist')"
            class="col-xs-12 col-sm-5 col-md-4 col-lg-3 p-0 mr-3 mt-3"
            :value="object.vetSpecialist"
            :editable="isEditable('vetSpecialist')"
            :feedback="liveFeedback('vetSpecialist')">
            <template #field>
                    <b-input
                        id="vetSpecialist"
                        class="w-100"
                         v-model="$v.form.vetSpecialist.$model"
                        :state="validateState('vetSpecialist')">
                    </b-input>
            </template>
        </form-field>

        <form-field  v-if="objectClass" :label="getFieldLabel('conclusion')"
            class="col-xs-12 col-md-6 col-lg-4 p-0 mr-3 mt-3 mb-5"
            :value="object.conclusion"
            :editable="isEditable('conclusion')"
            :feedback="liveFeedback('conclusion')">
            <template #field>
                    <b-textarea
                        id="conclusion"
                        class="w-100"
                         v-model="$v.form.conclusion.$model"
                        :state="validateState('conclusion')">
                    </b-textarea>
            </template>
        </form-field>

        <div class="col-12 p-0 m-0 d-flex flex-column">
            <h4>Акт освидетельствования</h4>

            <div class="d-flex flex-wrap p-0 col-12">
                <form-field  v-if="objectClass" :label="getFieldLabel('actNumber')"
                            class="col-xs-12 col-sm-3 p-0 mr-0 mr-sm-3 mb-3"
                            :value="object.actNumber"
                            :editable="isEditable('actNumber')"
                            :feedback="liveFeedback('actNumber')">
                    <template #field>
                            <b-input
                                id="actNumber"
                                class="w-100"
                                placeholder="№"
                                v-model="$v.form.actNumber.$model"
                                :state="validateState('actNumber')">
                            </b-input>
                    </template>
                </form-field>

                <date-time-picker  v-if="objectClass" class="col-xs-12 col-sm-6 col-md-4 mr-0 mr-sm-3 mb-2 p-0"
                          ref="actDate"
                          :title="getFieldLabel('actDate')"
                          name="actDate"
                          :editable="isEditable('actDate')"
                          :show-timepicker="false"
                          :date-required="false"
                          :key="getActDate() + '-a'"
                          :initial-date-string="getActDate()"
                          :state="validateState('actDate')"
                          @date-changed="onModelDateChanged" />

                <div class="d-flex flex-column flex-grow-1 col-12 m-0 p-0"  v-if="objectClass">
                    <div class="form-field-label text-secondary">Комиссия</div>
                    <div class="mb-3 border rounded p-3 d-flex flex-column">
                        <div class="d-flex align-items-center mb-3">
                            <span class="mr-2" :class="{'mt-2': !isEditable('chairman')}">Комиссией в составе председателя комиссии</span>
                            <form-field v-if="objectClass" class="col-xs-12 col-sm-6 col-md-5 col-lg-4 p-0"
                                :value="object.chairman"
                                :editable="isEditable('chairman')"
                                :feedback="liveFeedback('chairman')">
                                <template #field>
                                        <b-input
                                            id="chairman"
                                             v-model="$v.form.chairman.$model"
                                            placeholder="ФИО, должность"
                                            :state="validateState('chairman')">
                                        </b-input>
                                </template>
                            </form-field>
                        </div>
                        <div class="d-flex align-items-center mb-3">
                            <span class="mr-2" :class="{'mt-2': !isEditable('members')}">членов комиссии</span>
                            <form-field class="col-xs-12 col-sm-8 col-md-6 col-lg-5 p-0" v-if="objectClass"
                                :value="object.members"
                                :editable="isEditable('members')"
                                :feedback="liveFeedback('members')">
                                <template #field>
                                        <b-textarea
                                            id="members"
                                             v-model="$v.form.members.$model"
                                            :state="validateState('members')">
                                        </b-textarea>
                                </template>
                            </form-field>
                        </div>

                        <div class="d-flex align-items-center mb-3">
                            <span class="mr-2" :class="{'mt-2': !isEditable('omsuRepresentative')}">в присутствии</span>
                            <form-field class="col-xs-12 col-sm-8 col-md-6 col-lg-5 p-0" v-if="objectClass"
                                :value="object.omsuRepresentative"
                                :editable="isEditable('omsuRepresentative')"
                                :feedback="liveFeedback('omsuRepresentative')">
                                <template #field>
                                        <b-input
                                            id="omsuRepresentative"
                                             v-model="$v.form.omsuRepresentative.$model"
                                            placeholder="ФИО, должность представителя ОМСУ"
                                            :state="validateState('omsuRepresentative')">
                                        </b-input>
                                </template>
                            </form-field>
                        </div>

                        <div class="d-flex align-items-center mb-3">
                            <span class="mr-2" :class="{'mt-2': !isEditable('omsuRepresentativeHelper')}">помощник</span>
                            <form-field class="col-xs-12 col-sm-8 col-md-6 col-lg-5 p-0" v-if="objectClass"
                                :value="object.omsuRepresentativeHelper"
                                :editable="isEditable('omsuRepresentativeHelper')"
                                :feedback="liveFeedback('omsuRepresentativeHelper')">
                                <template #field>
                                        <b-input
                                            id="omsuRepresentativeHelper"
                                             v-model="$v.form.omsuRepresentativeHelper.$model"
                                            placeholder="ФИО"
                                            :state="validateState('omsuRepresentativeHelper')">
                                        </b-input>
                                </template>
                            </form-field>
                        </div>

                        <div class="d-flex align-items-center">
                            <span class="mr-2">составлен настоящий акт о проведении освидетельствования животного без владельца на предмет наличия (отсутствия) у него немотивированной агрессивности.</span>
                        </div>

                    </div>
                </div>

                <div class="d-flex flex-column flex-grow-1 col-12 m-0 p-0" v-if="objectClass">
                    <div class="form-field-label text-secondary">Этапы освидетельствования</div>
                    <div v-for="(stage, i) in form.getMetadata" class="mb-3 border rounded p-3" :key="i">
                        <strong>{{ stage.name }}</strong>
                        <form-field v-if="form.hasOwnProperty(reactionKey(stage['id'])) && $v.form[reactionKey(stage['id'])]" class="col-xs-12 p-0 mr-3 mt-3 mb-3"
                                    :editable="true"
                                    :feedback="liveFeedback(reactionKey(stage['id']))">
<!--                            <template #value>-->
<!--                                <span></span>-->
<!--                            </template>-->
                            <template #field>
                                <radio-list :id="reactionKey(stage['id'])"
                                            :name="reactionKey(stage['id'])"
                                            :url="reactionsUrl(stage['id'])"
                                            :editable="isEditable(reactionKey(stage['id']))"
                                            v-model="form[reactionKey(stage['id'])]"
                                            :label-key="'reaction'"
                                    @radio-changed="onReactionRadioChanged"/>
                            </template>
                        </form-field>
                        <div class="col-12 border-top p-0 pt-3">Уровень агрессивности: {{ form['levels-' + stage['id']] }}</div>

                    </div>
                </div>

                <div class="d-flex flex-column flex-grow-1 col-12 m-0 p-0"  v-if="objectClass">
                    <div class="form-field-label text-secondary">Решение</div>
                    <div class="mb-3 border rounded p-3">

                        <form-field class="col-xs-12 p-0 mr-3"
                                    :value="object.conclusionChoice"
                                    :editable="true"
                                    :feedback="liveFeedback('conclusionChoice')">
                            <template #field>
                                    <radio-list id="conclusionChoice"
                                                name="conclusionChoice"
                                                class="mb-3"
                                                :editable="isEditable('conclusionChoice')"
                                                :url="conclusionsUrl"
                                                v-model="form.conclusionChoice"
                                                @radio-changed="onModelObjectRadioChanged"/>
                            </template>
                        </form-field>
                        <div class="col-12 border-top p-0 pt-3"><strong>Принято открытым голосованием</strong></div>
                        <div class="d-flex col-12 p-0">
                            <form-field  v-if="objectClass"  :label="getFieldLabel('votedFor')"
                                        class="col-xs-12 col-sm-6 col-md-3 col-lg-2 p-0 mr-3 mt-3"
                                        :value="object.votedFor"
                                        :editable="isEditable('votedFor')"
                                        :feedback="liveFeedback('votedFor')">
                                <template #field>
                                    <b-input
                                        id="votedFor"
                                        class="w-100"
                                         v-model="$v.form.votedFor.$model"
                                        :state="validateState('votedFor')">
                                    </b-input>
                                </template>
                            </form-field>
                            <form-field  v-if="objectClass"  :label="getFieldLabel('votedAgainst')"
                                        class="col-xs-12 col-sm-6 col-md-3 col-lg-2 p-0 mr-3 mt-3"
                                        :value="object.votedAgainst"
                                        :editable="isEditable('votedAgainst')"
                                        :feedback="liveFeedback('votedAgainst')">
                                <template #field>
                                    <b-input
                                        id="votedAgainst"
                                        class="w-100"
                                         v-model="$v.form.votedAgainst.$model"
                                        :state="validateState('votedAgainst')">
                                    </b-input>
                                </template>
                            </form-field>
                        </div>
                        <form-field  v-if="objectClass" :label="getFieldLabel('specialOpinion')"
                            class="col-xs-12 col-md-6 col-lg-4 p-0 mr-3 mt-3"
                            :value="object.specialOpinion"
                            :editable="isEditable('specialOpinion')"
                            :feedback="liveFeedback('specialOpinion')">
                            <template #field>
                                    <b-textarea
                                        id="specialOpinion"
                                        class="w-100"
                                         v-model="$v.form.specialOpinion.$model"
                                        :state="validateState('specialOpinion')">
                                    </b-textarea>
                            </template>
                        </form-field>
                    </div>
                </div>
            </div>

        </div>


    </div>
</template>

<script>
    import {ObjectComponentMixin} from "@/components/Forms/ObjectComponentMixin";
    import {SurveyEventAttributes} from "./survey";
    import FormField from "../../../../components/Forms/FormField";
    import {AttributeMixin} from "@/pages/AppPages/Events/AttributeMixin";
    import api from "@/api";
    import httpClient from "@/http";
    import RadioList from "@/components/Select/RadioList.vue";
    import Vue from "vue";
    import DateTimePicker from "@/components/Forms/DateTimePicker.vue";
    import {todayStr} from "@/utils/dateFormat";

    export default {
        name: "SurveyAttributes",
        components: {DateTimePicker, RadioList, FormField },
        mixins: [ObjectComponentMixin, AttributeMixin],
        data() {
            return {
                stagesMetadata: {},
                levels: {}
            }
        },
        beforeMount() {
            const vm = this;
            vm.initialize();
            vm.initObjectParams['actDate'] = todayStr();
        },
        computed: {
            conclusionsUrl() {
                return api.surveyStages.conclusions.list()
            },
        },
        methods: {
            getActDate() {
                return this.object.actDate;
            },
            reactionKey(stageId) {
                return 'reactions-' + stageId
            },
            reactionsUrl(stageId) {
                return api.surveyStages.reactions.list(api.surveyStages.default.detail(stageId))
            },
            onReactionRadioChanged(name, item, data) {
                this.form['levels'][data['stage']] = this.form['levels-' + data['stage']] = data['level_text'];
                this.form[name] = item
                this.$v.form[name].$touch();
            },
            prepareData() {
                let data = ObjectComponentMixin.methods.prepareData.call(this);
                data['levels'] = this.form['levels'];
                data['reactionKeys'] = this.object.reactionKeys;
                data['levelKeys'] = this.object.levelKeys;
                return data;
            }
        },
        mounted() {
            const vm = this;

            httpClient.get(api.surveyStages.default.list())
                .then((response) => {
                    vm.initClassProperties = response.data['results'];
                    vm.objectClass = SurveyEventAttributes;
                    vm.onMount();
                    vm.resetForm();
                })
        }
    }
</script>

<style scoped lang="scss">

</style>